import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

let Config = new Vuex.Store({
    state: {
        appEnv: process.env.VUE_APP_ENV,
        apiHost: process.env.VUE_APP_API_URL,
        api123goldHost: process.env.VUE_APP_123GOLD_API_URL,
        orderPlatformHost: process.env.VUE_APP_ORDERPLATFORM_URL,
        jewelleryViewer3dHost: process.env.VUE_APP_JEWELLERY_VIEWER_3D_URL,
        appUrl: process.env.VUE_APP_APP_URL,
        diamondStockUrl: process.env.VUE_APP_DIAMONDSTOCK_URL,
        integrationUriPrafrix: '',
        visualMode: 'show',
        currentVarType: '',
        lastCurrentVarType: '',
        country: 'de',
        language: 'de',
        shopId: 0,
        website: '',
        isOnlyWishlist: false,
        showSideMenu: false,
        showLastConfigured: true,
        fitStoneWithWidth: true
    },
    actions: {
        setVisualMode(context, mode) {
            if (mode === 'show' || mode === 'conf' || mode === 'wishlist' || mode === 'images' || mode === 'warehouse') {
                context.commit('setVisualMode', mode);

                if (mode !== 'conf' && mode !== 'images') {
                    context.commit("setCurrentVarType", '');
                }
            }
        },
        setIntegrationUrlPrafix(context, urlPrafxi) {
            context.commit('setIntegrationUrlPrafix', urlPrafxi);
        },
        setCountry(context, country) {
            if (country.length === 2) {
                context.commit('setCountry', country);
            }
        },
        setLanguage(context, language) {
            if (language.length === 2) {
                context.commit('setLanguage', language);
            }
        },
        setWebsite(context, website) {
            website = website.trim();
            if (website !== '') {
                context.commit('setWebsite', website);
            }
        },
        setCurrentVarType(context, varType) {
            if (typeof varType === 'string' && varType !== "") {
                context.commit("setCurrentVarType", varType);
                context.commit('setVisualMode', 'conf');
            }
        },
        setShopId(context, shopId) {
            if (typeof shopId === 'number' && shopId > 10000) {
                context.commit("setShopId", shopId)
            } else {
                context.commit("setShopId", 0)
            }
        },
        setIsOnlyWishlist(context, status) {
            if (typeof status === 'boolean') {
                context.commit("setIsOnlyWishlist", status);
            }
        },
        setShowSideMenu(context, show) {
            if (typeof show === 'boolean') {
                context.commit("setShowSideMenu", show);
            }
        },
        setShowLastConfigured(context, show) {
            if (typeof show === 'boolean') {
                context.commit("setShowLastConfigured", show);
            }
        },
        setFitStoneWithWidth(context, fitStoneWithWidth) {
            if (typeof fitStoneWithWidth === 'boolean') {
                context.commit("setFitStoneWithWidth", fitStoneWithWidth);
            }
        }
    },
    mutations: {
        setVisualMode(state, mode) {
            if (mode === state.visualMode && mode === 'wishlist') {
                mode = 'show';
            }

            state.visualMode = mode;
        },
        setIntegrationUrlPrafix(state, urlPrafix) {
            if (urlPrafix.substring(-1, 1) === '/') {
                urlPrafix = urlPrafix.slice(0, -1);
            }
            state.integrationUriPrafrix = urlPrafix;
        },
        setCountry(state, country) {
            state.country = country;
        },
        setLanguage(state, language) {
            state.language = language;
        },
        setWebsite(state, website) {
            state.website = website;
        },
        setCurrentVarType(state, varType) {
            state.currentVarType = varType;
            if (varType !== "") {
                state.lastCurrentVarType = varType
            }
        },
        setShopId(state, shopId) {
            state.shopId = shopId
        },
        setIsOnlyWishlist(state, status) {
            state.isOnlyWishlist = status;
        },
        setShowSideMenu(state, show) {
            state.showSideMenu = show;
        },
        setShowLastConfigured(state, show) {
            state.showLastConfigured = show;
        },
        setFitStoneWithWidth(state, fitStoneWithWidth) {
            state.fitStoneWithWidth = fitStoneWithWidth;
        }
    },
    getters: {
        getApiHostWithLocalStr: state => {
            let host = state.apiHost;

            if (state.country + "-" + state.language !== 'de-de') {
                host += "/" + state.country + "-" + state.language;
            }

            return host;
        },
        getApiHost: state => {
            return state.apiHost;
        },
        getOrderPlatformHost: state => {
          return state.orderPlatformHost
        },
        getAppUrl: state => {
            return state.appUrl;
        },
        getDiamondStockUrl: state => {
            return state.diamondStockUrl;
        },
        getIntegrationUrlPrafix: state => {
            return state.integrationUriPrafrix;
        },
        getConfig: state => {
            return state;
        },
        getLocalStr: state => {
            return state.country + "-" + state.language;
        },
        getCountry: state => {
            return state.country;
        },
        getcurrentVarType: state => {
            return state.currentVarType;
        },
        getLastCurrentVarType: state => {
            return state.lastCurrentVarType;
        },
        getActiveShop: state => {
            return state.shopId
        },
        isShopLoginActive: state => {
            return (state.shopId > 10000)
        },
        getJewelleryViewer3dHost: state => {
            return state.jewelleryViewer3dHost
        },
        getApi123GoldHost: state => {
            return state.api123goldHost
        },
        getAppEnv: state => {
            return state.appEnv;
        },
        getWebsite: state => {
            return state.website;
        },
        getLanguage: state => {
            return state.language;
        },
        getIsOnlyWishlist: state => {
            return state.isOnlyWishlist;
        },
        getShowSideMenu: state => {
            return state.showSideMenu;
        },
        getShowLastConfigured: state => {
            return state.showLastConfigured;
        },
        getFitStoneWithWidth: state => {
            return state.fitStoneWithWidth;
        }
    }
});

export default Config;
